module.exports = __webpack_public_path__ + "static/media/linkedInImg.588d623a.svg";